var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC3DecorativeMatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 29v34h34V29H29zm26 26H37V37h18v18zm-2-30H25v28h-4V21h32v4zm-8-8H17v28h-4V13h32v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C3_Decorative_match.9b2bacdf.svg";
export { SvgC3DecorativeMatch as ReactComponent };